// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__hitmE","subheader":"ReorderModal_subheader__1RmHK","listWrap":"ReorderModal_listWrap__3cgtZ"};